import { render, staticRenderFns } from "./Panier.vue?vue&type=template&id=1a49b54e&"
import script from "./Panier.vue?vue&type=script&lang=js&"
export * from "./Panier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports